<template>
	<div>
		<case-form :schema="smokingStatus" class="mt6" />

		<div class="xs-12 fs4 fw7 mt6 mb2">
			Please provide the following details:
		</div>

		<div class="xs-12 fs4 fw7 mt6 mb2">Cigarettes</div>
		<case-form :schema="schemaCigarettes" />

		<div class="xs-12 fs4 fw7 mt6 mb2">Cigars</div>
		<case-form :schema="schemaCigars" />

		<div class="xs-12 fs4 fw7 mt6 mb2">Others</div>
		<case-form :schema="schemaOthers" />

		<div class="fs4 fw7 lh125 mt6 mb2">Have you ever had:</div>
		<case-form :schema="schemaPersonalHealth" />

		<div class="xs-12 fs4 fw7 mb2 mt6">
			Please provide details to any ‘yes’ answers above:
		</div>
		<j-accordion
			v-for="i in 7"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaDetails(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {}
	},

	computed: {
		smokingStatus() {
			return [
				{
					label:
						"Have you ever used tobacco or nicotine products in any form (including cigarettes, cigars, cigarillos, pipe, chewing tobacco, nicotine patches or gum)?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0useTobaccoOrNicotineProduct`,
					props: {
						suggest: {
							typeIncludes: `useTobaccoOrNicotineProduct`
						},
						createOptions: {
							type: `useTobaccoOrNicotineProduct`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaCigarettes() {
			return [
				{
					label: `Product`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigaretteProductUsed`,
					props: {
						suggest: {
							typeIncludes: `cigaretteProductUsed`
						},
						createOptions: {
							type: `cigaretteProductUsed`,
							dataType: "string"
						}
					}
				},
				{
					label: `Amount/Frequency`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigaretteAmountFrequency`,
					props: {
						suggest: {
							typeIncludes: `cigaretteAmountFrequency`
						},
						createOptions: {
							type: `cigaretteAmountFrequency`,
							dataType: "string"
						}
					}
				},
				{
					label: `Current`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeCigaretteCurrently`,
					props: {
						suggest: {
							typeIncludes: `smokeCigaretteCurrently`
						},
						createOptions: {
							type: `smokeCigaretteCurrently`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Past`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeCigaretteInPast`,
					props: {
						suggest: {
							typeIncludes: `smokeCigaretteInPast`
						},
						createOptions: {
							type: `smokeCigaretteInPast`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Date Last Used`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigaretteDateLastUsed`,
					props: {
						suggest: {
							typeIncludes: `cigaretteDateLastUsed`
						},
						createOptions: {
							type: `cigaretteDateLastUsed`,
							dataType: "date"
						}
					}
				}
			]
		},

		schemaCigars() {
			return [
				{
					label: `Product`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigarProductUsed`,
					props: {
						suggest: {
							typeIncludes: `cigarProductUsed`
						},
						createOptions: {
							type: `cigarProductUsed`,
							dataType: "string"
						}
					}
				},
				{
					label: `Amount/Frequency`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigarAmountFrequency`,
					props: {
						suggest: {
							typeIncludes: `cigarAmountFrequency`
						},
						createOptions: {
							type: `cigarAmountFrequency`,
							dataType: "string"
						}
					}
				},
				{
					label: `Current`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeCigarCurrently`,
					props: {
						suggest: {
							typeIncludes: `smokeCigarCurrently`
						},
						createOptions: {
							type: `smokeCigarCurrently`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Past`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeCigarInPast`,
					props: {
						suggest: {
							typeIncludes: `smokeCigarInPast`
						},
						createOptions: {
							type: `smokeCigarInPast`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Date Last Used`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cigarDateLastUsed`,
					props: {
						suggest: {
							typeIncludes: `cigarDateLastUsed`
						},
						createOptions: {
							type: `cigarDateLastUsed`,
							dataType: "date"
						}
					}
				}
			]
		},

		schemaOthers() {
			return [
				{
					label: `Product`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherProductUsed`,
					props: {
						suggest: {
							typeIncludes: `otherProductUsed`
						},
						createOptions: {
							type: `otherProductUsed`,
							dataType: "string"
						}
					}
				},
				{
					label: `Amount/Frequency`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherAmountFrequency`,
					props: {
						suggest: {
							typeIncludes: `otherAmountFrequency`
						},
						createOptions: {
							type: `otherAmountFrequency`,
							dataType: "string"
						}
					}
				},
				{
					label: `Current`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeOtherCurrently`,
					props: {
						suggest: {
							typeIncludes: `smokeOtherCurrently`
						},
						createOptions: {
							type: `smokeOtherCurrently`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Past`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0smokeOtherInPast`,
					props: {
						suggest: {
							typeIncludes: `smokeOtherInPast`
						},
						createOptions: {
							type: `smokeOtherInPast`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Date Last Used`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDateLastUsed`,
					props: {
						suggest: {
							typeIncludes: `otherDateLastUsed`
						},
						createOptions: {
							type: `otherDateLastUsed`,
							dataType: "date"
						}
					}
				}
			]
		},
		schemaPersonalHealth() {
			return [
				{
					label: `15a) Chest pain, heart attack, shortness of breath, heart murmur, high blood pressure, stroke, irregular heart beat, or
any other disease or disorder of the heart or arteries?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15A`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15A`
						},
						createOptions: {
							type: `healthHistoryQuestion15A`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15b) Diabetes, elevated blood sugar or glucose intolerance or disease of any glands?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15B`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15B`
						},
						createOptions: {
							type: `healthHistoryQuestion15B`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15c) Mental or emotional disorder, nervous breakdown, convulsions, epilepsy, paralysis or any other disorder of the brain or
nervous system?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15C`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15C`
						},
						createOptions: {
							type: `healthHistoryQuestion15C`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15d) Arthritis, gout, or any bone, joint muscle or skin disorder?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15D`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15D`
						},
						createOptions: {
							type: `healthHistoryQuestion15D`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15e) Asthma, bronchitis, pneumonia or any lung disorder?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15E`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15E`
						},
						createOptions: {
							type: `healthHistoryQuestion15E`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15f) Cirrhosis, hepatitis, ulcer, colitis, diverticulitis, ileitis or other disease of the liver, gall bladder, pancreas, stomach or intestines?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15F`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15F`
						},
						createOptions: {
							type: `healthHistoryQuestion15F`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15g) Prostate or testicular disease, disease of the uterus, cervix, ovaries or breasts?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15G`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15G`
						},
						createOptions: {
							type: `healthHistoryQuestion15G`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15h) Anemia, leukemia, clotting disorders, platelet disorders, infections, or sources of blood loss?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15H`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15H`
						},
						createOptions: {
							type: `healthHistoryQuestion15H`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15i) Disorder of the urinary tract or kidneys, sugar, albumin or blood in the urine?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15I`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15I`
						},
						createOptions: {
							type: `healthHistoryQuestion15I`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15j) Cancer or tumors?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15J`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15J`
						},
						createOptions: {
							type: `healthHistoryQuestion15J`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15k) An operation or admission to a hospital or any other health care facility, for observation, treatment of any illness or
diagnostic tests including treadmill stress test for insurance?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15K`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15K`
						},
						createOptions: {
							type: `healthHistoryQuestion15K`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15l) Acquired Immune Deficiency Syndrome (AIDS) or a positive blood test for the AIDS (HIV) virus?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15L`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15L`
						},
						createOptions: {
							type: `healthHistoryQuestion15L`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `15m) Any other health impairment or medically treated condition?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion15M`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion15M`
						},
						createOptions: {
							type: `healthHistoryQuestion15M`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `16a) used amphetamines, barbiturates, cannabis (marijuana), cocaine, hallucinogens, opiates or any prescription drug
other than as prescribed by a doctor?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion16A`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion16A`
						},
						createOptions: {
							type: `healthHistoryQuestion16A`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `16b) been advised to limit or discontinue the use of alcohol or drugs, sought or received treatment or participated in a group
for alcohol or drug use?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestion16B`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestion16B`
						},
						createOptions: {
							type: `healthHistoryQuestion16B`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaDetails(i) {
			return [
				{
					label: `Question Number`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryQuestionNumberFor${i}`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryQuestionNumberFor${i}`
						},
						createOptions: {
							type: `healthHistoryQuestionNumberFor${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryDateFor${i}`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryDateFor${i}`
						},
						createOptions: {
							type: `healthHistoryDateFor${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Details including diagnosis, treatment, tests done, results
and current status.`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryDetailsFor${i}`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryDetailsFor${i}`
						},
						createOptions: {
							type: `healthHistoryDetailsFor${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Name, Address, Country and Telephone Number of
Attending Doctor or Hospital`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0healthHistoryDoctorFor${i}`,
					props: {
						suggest: {
							typeIncludes: `healthHistoryDoctorFor${i}`
						},
						createOptions: {
							type: `healthHistoryDoctorFor${i}`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
